import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import DataTable from "../../../lib/components/DataTable";
import EmptyState from "../../../lib/components/EmptyState";
import pathnames from "../../../constants/pathnames";

/* -------------------------------------------------------------------------- */
/* Status Badge                                                               */
/* -------------------------------------------------------------------------- */

function Status({ status }) {
  if (status === "ACTIVE") return <div className="badge rounded-pill fw-medium fs-sm bg-primary text-primary bg-opacity-25">Active</div>;

  if (status === "EXPIRED") return <div className="badge bg-danger text-danger rounded-pill fw-medium fs-sm bg-opacity-25">Expired</div>;

  return <div className="badge bg-warning text-warning rounded-pill fw-medium fs-sm bg-opacity-25">Inactive</div>;
}

/* -------------------------------------------------------------------------- */
/* Component                                                                  */
/* -------------------------------------------------------------------------- */

const SubscribersTable = ({ data = [], isLoading, page, pageSize, totalPages, onPageChange, onPageSizeChange }) => {
  if (isLoading) return null;

  const columns = [
    {
      key: "client",
      header: "Client",
      render: (_, row) => (
        <Link to={`${pathnames.ORGANIZATIONS}/${row?.id}`} className="fw-medium">
          {row?.name}
        </Link>
      ),
    },
    {
      key: "email",
      header: "Email Address",
    },
    {
      key: "joinDate",
      header: "Joined Date",
      type: "date",
      render: (value) => (value ? moment(value).format("Do MMM, YYYY") : "N/A"),
    },
    {
      key: "contact",
      header: "Contact Person",
      render: (_, row) => (
        <Link to={`${pathnames.USERS}/${row?.owner?.accountId}`} className="fw-medium">
          {row?.owner?.firstName} {row?.owner?.lastName}
        </Link>
      ),
    },
    {
      key: "status",
      header: "Status",
      render: (_, row) => <Status status={row?.subscription?.status} />,
    },
    {
      key: "members",
      header: "Members",
      render: (_, row) => `${row?.membersCount ?? 0} user(s)`,
    },
    {
      key: "platform",
      header: "Sign-up Platform",
      render: (_, row) => row?.owner?.tracking?.signup?.platform?.type || "N/A",
    },
  ];

  return (
    <>
      <DataTable
        data={data}
        columns={columns}
        isLoading={isLoading}
        page={page}
        pageSize={pageSize}
        totalPages={totalPages}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />

      <EmptyState isEmpty={!isLoading && !data.length} />
    </>
  );
};

export default SubscribersTable;
